export default __webpack_public_path__ + "static/media/basis.d4f237e5.svg";